import { createSlice } from "@reduxjs/toolkit";
import { reducerRegistry } from "@/utils/redux";
import { initialState, reducers } from "./reducers";

const slice = createSlice({
  name: "FaqArticle",
  initialState,
  reducers,
});

export const { actions, reducer } = slice;
export const { getFaqArticle, getFaqArticleError, getFaqArticleSuccess } =
  slice.actions;

reducerRegistry.register("faqArticle", reducer);
